// 취소 사유 입력 공용 다이얼로그. 수금(지급) 취소(BillCollectService.cancelCollect 계열)는
// 금액 이력이라 "왜 취소했는지"가 남아야 해서 사유가 필수다.
//
// OrderBillReviewContainer의 로컬 ReasonDialog와 같은 모양이다 - 레거시
// TaxBillColAndPayForm(taxbillmng/taxIssuedmng/paymentmng 3곳)의 수금(지급) 취소 버튼이
// 새로 이 다이얼로그를 쓴다(레거시 수금 입력을 BillCollectAddDialog/BillCollectService로
// 통합, 2026-10-21). 기존 OrderBillReviewContainer 쪽은 그대로 둔다(동작 중인 코드를
// 건드리지 않는다).
import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

const ReasonDialog = ({ open, title, required = true, onCancel, onConfirm }) => {
  const [reason, setReason] = useState('');
  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={2}
          label={required ? '취소 사유 (필수)' : '취소 사유 (선택)'}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>취소</Button>
        <Button
          variant="contained"
          color="warning"
          disabled={required && !reason.trim()}
          onClick={() => onConfirm(reason.trim())}
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReasonDialog;
